import React, { useState } from "react";
import { edit_icon } from "../../../assets/imgs";
import { alertList } from "../../redux/api/dummyJson";
import { toast } from "react-toastify";
import { URL } from "../../../Services/Constant";
import { post } from "../../../Services/ApiHandler";

const SiteAlertEscalation = ({
  alertDatas,
  setAlertDatas,
  getAlertEsculation,
}) => {
  // Table data
  const [rows, setRows] = useState([
    {
      sno: 1,
      severity: 1,
      groups: "Group 1 → Group 2",
      time: 10,
    },
    {
      sno: 2,
      severity: 1,
      groups: "Group 2 → Group 3",
      time: 15,
    },
    {
      sno: 3,
      severity: 2,
      groups: "Group 1 → Group 2",
      time: 20,
    },
    {
      sno: 4,
      severity: 2,
      groups: "Group 2 → Group 3",
      time: 25,
    },
    {
      sno: 5,
      severity: 3,
      groups: "Group 1 → Group 2",
      time: 30,
    },
    {
      sno: 6,
      severity: 3,
      groups: "Group 2 → Group 3",
      time: 35,
    },
  ]);

  const [editIndex, setEditIndex] = useState(null);
  const [tempTime, setTempTime] = useState("");

  const handleEdit = (index) => {
    setEditIndex(index);
    setTempTime(alertDatas?.[index].escalation_minutes);
  };

  const handleCancel = () => {
    setEditIndex(null);
    setTempTime("");
  };

  const handleSave = (index, item) => {
    let formdata = new FormData();
    formdata.append("id", item?.id);
    formdata.append("knf_company_site_id", item?.site_id);
    formdata.append("severity", item?.severity);
    formdata.append("from_group", item?.from_group);
    formdata.append("to_group", item?.to_group);
    formdata.append("escalation_minutes", tempTime);
    post(URL.SITE_ALERT_ESCULATION_UPDATE, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getAlertEsculation();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    const updated = [...rows];
    updated[index].time = tempTime;
    setRows(updated);
    setEditIndex(null);
  };

  return (
    <div className=" ">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {alertDatas?.length}
        </h2>
      </div>

      <table className="table table-bordered m-3">
        <thead>
          <tr className="text-center">
            <th>S.No</th>
            <th>Severity</th>
            <th>Groups</th>
            <th>Time (mins)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {alertDatas?.map((row, i) => {
            const isEditing = editIndex === i;
            return (
              <tr key={i} className="text-center">
                <td>{i + 1}</td>
                <td>{row?.severity}</td>
                <td className="text-nowrap">
                  {row?.from_group ? `Group  ${row?.from_group} ` : ""}
                  {row?.to_group ? `→ Group  ${row?.to_group}` : ""}
                </td>
                <td>
                  {isEditing ? (
                    <input
                      type="text"
                      value={tempTime}
                      onChange={(e) => setTempTime(e.target.value)}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 2))
                      }
                      className="input-box w-50 text-center"
                    />
                  ) : (
                    <input
                      type="text"
                      value={row?.escalation_minutes}
                      disabled
                      className="input-box w-50 text-center"
                    />
                  )}
                </td>
                <td>
                  {isEditing ? (
                    <div div className="d-flex ac-jc gap-3">
                      <button
                        className="save-btn"
                        onClick={() => handleSave(i, row)}
                        style={{
                          height: "40px",
                        }}
                      >
                        Save
                      </button>
                      <button
                        className="cancel-btn"
                        onClick={handleCancel}
                        style={{
                          height: "40px",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <button className="cust-btn " onClick={() => handleEdit(i)}>
                      <img src={edit_icon} alt="" className=" edit-btn " />
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SiteAlertEscalation;
